import { render, staticRenderFns } from "./FormNested.vue?vue&type=template&id=04488bf7&"
import script from "./FormNested.vue?vue&type=script&lang=js&"
export * from "./FormNested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports